export default "__VITE_ASSET__DmYRfbmR__"